import React from 'react';

/**
 * The page's horizontal rhythm.
 *
 * In Figma the content runs from x=190 to x=1730 inside a 1920 frame, which is
 * a 1536px column with 192px of air on each side. Every section uses this so
 * headings, cards and the footer all line up on the same two edges.
 */
const Container = ({ as: Element = 'div', className = '', children, ...rest }) => (
    <Element
        className={`tw-mx-auto tw-w-full tw-max-w-v2-container tw-px-5 md:tw-px-10 ${className}`}
        {...rest}
    >
        {children}
    </Element>
);

export default Container;
